import { render, staticRenderFns } from "./ProductTypeBundle.vue?vue&type=template&id=6048bbf9"
import script from "./ProductTypeBundle.vue?vue&type=script&lang=ts"
export * from "./ProductTypeBundle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports